import {Component, Input, signal} from '@angular/core';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {
  ISupplierCodeAutoFillModalResult,
  SupplierCodeAutoFillModalMode,
} from '../../models/supplier-code-auto-fill.interface';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';

@Component({
  selector: 'app-stock-manager-supplier-code-auto-fill-modal',
  templateUrl: './stock-manager-supplier-code-auto-fill-modal.component.html',
  styleUrls: ['./stock-manager-supplier-code-auto-fill-modal.component.scss'],
  standalone: false,
})
export class StockManagerSupplierCodeAutoFillModalComponent {

  @Input() mode: SupplierCodeAutoFillModalMode = 'confirm';
  @Input() supplierCode = '';
  @Input() stockCode = '';

  protected readonly doNotAskAgain = signal<boolean>(false);
  protected readonly icons = IconsEnum;

  constructor(
    private readonly modalController: ModalControllerService,
  ) {
  }

  protected onDoNotAskAgainChange(event: Event): void {
    this.doNotAskAgain.set((event.target as HTMLInputElement).checked);
  }

  protected async onCancel(): Promise<void> {
    await this.dismiss({action: 'cancel', doNotAskAgain: this.doNotAskAgain()});
  }

  protected async onAccept(): Promise<void> {
    await this.dismiss({action: 'accept', doNotAskAgain: this.doNotAskAgain()});
  }

  private async dismiss(result: ISupplierCodeAutoFillModalResult): Promise<void> {
    await this.modalController.dismiss(result);
  }
}
